import { pxToRem } from '../../../../utils';
export var formLabelVariables = function formLabelVariables(siteVariables) {
  return {
    lineHeight: pxToRem(16),
    marginBottom: pxToRem(4)
  };
};